import { render, staticRenderFns } from "./SourceIcons.vue?vue&type=template&id=25dc7bcb&"
import script from "./SourceIcons.vue?vue&type=script&lang=ts&"
export * from "./SourceIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports